/** The user asked the system for less motion: animations that JS drives (Sortable, a looping canvas) check this. */
export function prefersReducedMotion(): boolean {
  return typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches
}
